'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDevices = function MdDevices(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 28.4v-11.8h-6.6v11.8h6.6z m1.8-15q0.7 0 1.1 0.4t0.5 1.2v16.6q0 0.7-0.5 1.3t-1.1 0.5h-10q-0.7 0-1.3-0.5t-0.5-1.3v-16.6q0-0.7 0.5-1.2t1.3-0.4h10z m-31.8-3.4v18.4h16.8v5h-23.4v-5h3.4v-18.4q0-1.3 0.9-2.3t2.3-1.1h30v3.4h-30z' })
        )
    );
};

exports.default = MdDevices;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/devices.js
// module id = 916
// module chunks = 36573943044255 79611799117203 213534597649335